@if (content) {
  <sd-component-wrapper
    [componentWidth]="componentWidth"
    [content]="content"
    [layout]="layout"
    [layoutTextConfig]="layoutTextConfig"
    [marginSize]="marginSize"
    [textConfig]="textConfig"
    [themesConfig]="themesConfig"
    [brand]="brand"
    [activeBrand]="activeBrand"
    (linkClicked)="onLinkClicked($event)"
  >
    <ng-content sd-component-wrapper-component select="[sd-component-wrapper-component]" />
  </sd-component-wrapper>
}
